import { render, staticRenderFns } from "./RacerSupportWidget.vue?vue&type=template&id=6147bbe0"
import script from "./RacerSupportWidget.vue?vue&type=script&lang=js"
export * from "./RacerSupportWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports